import { KSelectRangeDate, KSpan } from "kahuna-base-react-components"
import { useMemo, useState } from "react"
import { lang } from "../../../constants/languages"
import ArtistOverview from "./artist-overview/ArtistOverview"
import PlatformPerformance from "./platform-performance/PlatformPerformance"
import TrackPerformance from "./track-performance/TrackPerformance"
import AudienceAndDiscovery from "./audience-and-discovery/AudienceAndDiscovery"
import Trends from "../trends/Trends"
import { DateRangeType } from "kahuna-base-react-components/dist/components/KSelectRange/KSelectRange"
import { ANALYSIS_TAB_OPTIONS, defaultEndDate, defaultStartDate, errorFilledToastOptions } from "../../../constants"
import { formatDate, toYYYYMMDD } from "../../../utility"
import { toast } from "react-toastify"
import { KSelectOption } from "kahuna-base-react-components/dist/components/KDropdown/KDropdown"

const MILISECONDS_MONTH = 2592000000 // 30 days => 30 days as time-length as miliseconds but when applied to day difference 30 + 1, because 1 day difference => today - prev_day = 2 days

export type AnalysisProps = {
  isAdmin: boolean
  selectedUsers?: KSelectOption[]
}

const Analysis = ({ isAdmin, selectedUsers }: AnalysisProps) => {
  const [selectedTab, setSelectedTab] = useState(isAdmin ? undefined : ANALYSIS_TAB_OPTIONS.ARTIST_OVERVIEW)
  const [dateValues, setDateValues] = useState<DateRangeType>([defaultStartDate, defaultEndDate])
  const renderTabs = () => {
    return (
      <div className="w-full flex flex-row items-center justify-between gap-3 flex-wrap-reverse">
        <div className="flex gap-4 ml-3">
          {Object.values(ANALYSIS_TAB_OPTIONS).map((option) => {
            return (
              <div
                key={`${option}`}
                className="cursor-pointer"
                onClick={() => {
                  setSelectedTab(option)
                }}
                style={{ borderBottom: selectedTab === option ? "1px solid #666666" : "" }}
              >
                <KSpan
                  text={lang.analytics[option].tab_title}
                  fontWeight={selectedTab === option ? 500 : 400}
                  color={selectedTab === option ? "#111111" : ""}
                />
              </div>
            )
          })}
        </div>
        <div className="flex flex-row items-center gap-3">
          <KSpan
            text={`${formatDate(toYYYYMMDD((dateValues as Date[])[0]))} - ${formatDate(
              toYYYYMMDD((dateValues as Date[])[1])
            )}`}
            color="#111"
            fontWeight={500}
          />
          <KSelectRangeDate
            value={dateValues}
            onChange={(dateRange) => {
              //@ts-ignore
              if (dateRange[1] - dateRange[0] > MILISECONDS_MONTH) {
                toast.error(lang.trends.error_month_range_limit, errorFilledToastOptions)
                return
              }
              setDateValues(dateRange)
            }}
            maximumDate={new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000)} // 2 days
            height="36px"
            width="36px"
            backgroundColor="#F7F7F7"
            hoverBackgroundColor="#F3F3F3"
            boxShadow="none"
            shorthandEndDateOffsetDays={2}
          />
        </div>
      </div>
    )
  }

  const selectedUsersParam = useMemo(() => {
    if (!(selectedUsers && selectedUsers.length > 0 && isAdmin)) return ""
    const userIdList = selectedUsers.map((selectedUser: KSelectOption) => {
      return selectedUser.value
    })
    const usersParam = userIdList.join(",")
    return usersParam
  }, [selectedUsers, isAdmin])

  return (
    <div className="flex flex-col gap-2 p-2 mt-7">
      <div className="w-full flex items-center">{renderTabs()}</div>
      {!selectedTab && (
        <div className="pl-3 mt-6">
          <KSpan text="Select to view" lineHeight="20px" />
        </div>
      )}
      <div style={{ display: selectedTab === ANALYSIS_TAB_OPTIONS.ARTIST_OVERVIEW ? "block" : "none" }}>
        <ArtistOverview dateValues={dateValues} selectedTab={selectedTab} selectedUsersParam={selectedUsersParam} isAdmin={isAdmin}/>
      </div>
      <div style={{ display: selectedTab === ANALYSIS_TAB_OPTIONS.PLATFORM_PERFORMANCE ? "block" : "none" }}>
        <PlatformPerformance dateValues={dateValues} selectedTab={selectedTab} selectedUsersParam={selectedUsersParam} isAdmin={isAdmin}/>
      </div>
      <div style={{ display: selectedTab === ANALYSIS_TAB_OPTIONS.TRACK_PERFORMANCE ? "block" : "none" }}>
        <TrackPerformance dateValues={dateValues} selectedTab={selectedTab} selectedUsersParam={selectedUsersParam} isAdmin={isAdmin}/>
      </div>
      <div style={{ display: selectedTab === ANALYSIS_TAB_OPTIONS.AUDIENCE ? "block" : "none" }}>
        <AudienceAndDiscovery dateValues={dateValues} selectedTab={selectedTab} selectedUsersParam={selectedUsersParam} isAdmin={isAdmin}/>
      </div>
      {(selectedTab === ANALYSIS_TAB_OPTIONS.TRENDS_DAILY ||
        selectedTab === ANALYSIS_TAB_OPTIONS.TRENDS_COUNTRY ||
        selectedTab === ANALYSIS_TAB_OPTIONS.TRENDS_DEMOGRAPHIC) && (
        <Trends isAdmin={isAdmin} externalTab={selectedTab} commonDateValues={dateValues} selectedUsers={selectedUsers} />
      )}
      {/*<div
        style={{
          display:
            selectedTab === ANALYSIS_TAB_OPTIONS.TRENDS_DAILY ||
            selectedTab === ANALYSIS_TAB_OPTIONS.TRENDS_COUNTRY ||
            selectedTab === ANALYSIS_TAB_OPTIONS.TRENDS_DEMOGRAPHIC
              ? "block"
              : "none"
        }}
      >
        <Trends isAdmin={false} externalTab={selectedTab} hideSideBarAndTitle={true} commonDateValues={dateValues} />
      </div>*/}
    </div>
  )
}
export default Analysis
